export * from './ActorRdfUpdateHypermediaPatchSparqlUpdate';
export * from './QuadDestinationPatchSparqlUpdate';
